// Fix sticky buy bar (Claude) - 2026-07-30 (v3)
// 1) Posiziona il pulsante "torna su" appena sopra alla barra sticky
//    "Acquista", misurando l'altezza reale della barra.
// 2) Il badge cookie di iubenda ha uno z-index inline fortissimo quindi
//    appare sempre sopra a qualunque elemento della pagina. Lo abbassiamo
//    solo mentre la barra sticky e' visibile su mobile.
// 3) Il prezzo nella barra sticky viene renderizzato una sola volta al
//    caricamento della pagina e NON ha l'id univoco ("price-{{ section.id }}")
//    che il tema usa per sapere quali elementi aggiornare quando si cambia
//    variante. Risultato: cambiando variante il prezzo nella pagina si
//    aggiorna ma quello nella barra sticky resta fermo al primo prezzo
//    mostrato. Lo teniamo sincronizzato osservando il prezzo "vero" (quello
//    dentro .buy-box-price-wrapper) e copiandone il contenuto ogni volta che
//    cambia, qualunque sia il meccanismo che il tema usa per aggiornarlo.
// Attivo solo su mobile (<=576px) per i punti 1 e 2; il punto 3 e' utile in
// generale (anche se la barra sticky su desktop e' nascosta di default, non
// costa nulla tenerla sincronizzata comunque).
(function () {
  var COOKIE_BTN_SELECTOR = '.iubenda-tp-btn.iubenda-cs-preferences-link';
  var originalCookieZ = null;

  function isMobile() {
    return window.matchMedia('(max-width: 576px)').matches;
  }

  function update() {
    var bar = document.querySelector('.sticky-add-to-cart');
    var scrollTop = document.querySelector('.scroll-top');
    var cookieBtn = document.querySelector(COOKIE_BTN_SELECTOR);
    if (!bar) return;

    var active = isMobile() && bar.classList.contains('active');

    if (scrollTop) {
      if (active) {
        var height = bar.offsetHeight;
        if (height > 0) {
          scrollTop.style.bottom = (height + 4) + 'px';
        }
      } else {
        scrollTop.style.bottom = '';
      }
    }

    if (cookieBtn) {
      if (originalCookieZ === null) {
        originalCookieZ = cookieBtn.style.zIndex || '2147483647';
      }
      if (active) {
        cookieBtn.style.setProperty('z-index', '1', 'important');
      } else {
        cookieBtn.style.setProperty('z-index', originalCookieZ, 'important');
      }
    }
  }

  var bar = document.querySelector('.sticky-add-to-cart');
  if (bar) {
    var observer = new MutationObserver(update);
    observer.observe(bar, { attributes: true, attributeFilter: ['class'] });
  }

  window.addEventListener('resize', update);
  window.addEventListener('load', update);
  document.addEventListener('DOMContentLoaded', update);
  update();
  setTimeout(update, 1000);
  setTimeout(update, 3000);

  // --- Sincronizzazione prezzo sticky bar ---
  function initPriceSync() {
    var sourceRoot = document.querySelector('.buy-box-price-wrapper');
    var stickyWrapper = document.querySelector(
      '.sticky-add-to-cart .sticky-add-to-cart__price-wrapper'
    );
    if (!sourceRoot || !stickyWrapper) return;

    var STATE_CLASSES = ['price--on-sale', 'price--sold-out', 'price--no-compare'];

    function syncPrice() {
      var mainPrice = sourceRoot.querySelector('.price');
      var stickyPrice = stickyWrapper.querySelector('.price');
      if (!mainPrice || !stickyPrice) return;
      if (stickyPrice.innerHTML !== mainPrice.innerHTML) {
        stickyPrice.innerHTML = mainPrice.innerHTML;
      }
      STATE_CLASSES.forEach(function (cls) {
        stickyPrice.classList.toggle(cls, mainPrice.classList.contains(cls));
      });
    }

    var priceObserver = new MutationObserver(syncPrice);
    priceObserver.observe(sourceRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    syncPrice();
  }

  initPriceSync();
  document.addEventListener('DOMContentLoaded', initPriceSync);
  window.addEventListener('load', initPriceSync);
})();
